import { render, staticRenderFns } from "./XFieldFileImagePicker.vue?vue&type=template&id=3f7445b6&scoped=true"
import script from "./XFieldFileImagePicker.vue?vue&type=script&lang=js"
export * from "./XFieldFileImagePicker.vue?vue&type=script&lang=js"
import style0 from "./XFieldFileImagePicker.vue?vue&type=style&index=0&id=3f7445b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7445b6",
  null
  
)

export default component.exports